import AsyncStorage from '@react-native-community/async-storage';
import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';

import {
  Actions,
  State,
  UI_HIDE_SNACKBAR,
  UI_SET_HOME,
  UI_SET_IMMIGRATION_HOME,
  UI_SET_LANGUAGE,
  UI_SET_PRIME_HOME,
  UI_SET_SEARCH,
  UI_SET_THEME,
  UI_SET_TOUR_FILTER,
  UI_SET_TOUR_HOME,
  UI_SET_TOUR_SEARCH,
  UI_SET_VERSION,
  UI_SHOW_SNACKBAR,
} from './types';

const initialState: State = {
  search: '',
  tourSearch: '',
  tourFilter: {
    priceRange: undefined,
    activeTerms: undefined,
  },
  theme: 'dark',
  language: 'fa',
  snackBar: {
    visible: false,
  },
  primeHome: [],
  immigrationHome: [],
  tourHome: [],
  version: 0,
  home: [],
};

const reducer: Reducer<State, Actions> = (state = initialState, action) => {
  switch (action.type) {
    case UI_SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case UI_SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case UI_SHOW_SNACKBAR:
      return {
        ...state,
        snackBar: {
          visible: true,
          message: action.payload,
        },
      };
    case UI_HIDE_SNACKBAR:
      return {
        ...state,
        snackBar: {
          visible: false,
        },
      };
    case UI_SET_PRIME_HOME:
      return {
        ...state,
        primeHome: action.payload,
      };
    case UI_SET_IMMIGRATION_HOME:
      return {
        ...state,
        immigrationHome: action.payload,
      };
    case UI_SET_TOUR_HOME:
      return {
        ...state,
        tourHome: action.payload,
      };
    case UI_SET_VERSION:
      return {
        ...state,
        version: action.payload,
      };
    case UI_SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case UI_SET_TOUR_SEARCH:
      return {
        ...state,
        tourSearch: action.payload,
      };
    case UI_SET_TOUR_FILTER:
      return {
        ...state,
        tourFilter: {
          activeTerms: { ...action.payload.activeTerms },
          priceRange: [
            ...(action.payload.priceRange ?? state.tourFilter.priceRange ?? []),
          ],
        },
      };
    case UI_SET_HOME:
      return {
        ...state,
        home: action.payload,
      };
    default:
      return state;
  }
};

export default persistReducer(
  {
    key: 'ui',
    storage: AsyncStorage,
    blacklist: ['snackBar', 'search', 'tourSearch', 'tourFilter'],
  },
  reducer
);
